import { useEffect, useState, useContext } from 'react';
import * as Router from 'react-router-dom';
import * as Hash from 'object-hash';
import { AuthContext } from '../../containers/App';

import * as COM from '.';
import * as Antd from 'antd';

export const callAction = async (props) => {
    return COM.actionCall(props, { accessToken: localStorage.getItem('access_token') });
}

export const ActionCall = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const auth = useContext(AuthContext);
    let history = Router.useHistory();

    const call = async () => {
        setLoading(true);

        let msg = null;
        let payloadHash = Hash.MD5(props.payload);
        let msgKey = `action-call-${props.action}-${payloadHash}`;

        if (props.showProcessingMessage === undefined || props.showProcessingMessage) {
            msg = Antd.message.loading({ content: 'Processing...', key: msgKey, duration: 30 });
        }

        let data = await COM.actionCall(props, auth);
        setData(data);

        setLoading(false);

        if (props.onSuccess) {
            props.onSuccess(data);
        }

        if (data.message && data.type === undefined) {
            Antd.message.info({ content: data.message, key: msgKey, duration: 10 });
        } else if (data.message && data.type === 'success') {
            Antd.message.success({ content: data.message, key: msgKey, duration: 10 });
        } else if (data.message && data.type === 'warning') {
            Antd.message.warning({ content: data.message, key: msgKey, duration: 10 });
        } else if (data.message && data.type === 'error') {
            Antd.message.error({ content: data.message, key: msgKey, duration: 10 });
        }

        if (data.redirect) {
            history.replace(data.redirect);
        }
    }

    useEffect(() => {
        if (props.callOnInit) {
            call();
        }
    }, props.invalidateEffect ? props.invalidateEffect : [])

    if (props.children) {
        return props.children(call, loading, data);
    } else {
        return null;
    }
};